import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { MyTaskDto, PersonDto, TaskDto } from "@klantpunt/shared";
import { api } from "../../lib/api";
import { can, useMe } from "../../lib/auth";
import { issuesKey } from "../issues/useIssues";

export const tasksKey = (buildingId: string) => ["tasks", buildingId] as const;
export const myTasksKey = ["my-tasks"] as const;

export function useTasks(buildingId: string, enabled = true) {
  return useQuery({
    queryKey: tasksKey(buildingId),
    queryFn: () => api<TaskDto[]>(`/buildings/${buildingId}/tasks`),
    enabled,
  });
}

export function useMyTasks() {
  return useQuery({ queryKey: myTasksKey, queryFn: () => api<MyTaskDto[]>("/my/tasks") });
}

export function usePeople() {
  const { data: me } = useMe();
  return useQuery({
    queryKey: ["people", me?.org?.id],
    queryFn: () => api<PersonDto[]>("/org/people"),
    enabled: can(me, "task.manage"),
    staleTime: 5 * 60_000,
  });
}

/** Na een taakwijziging: taken, bevindingen (status/taakcode) en "Mijn taken" verversen. */
export function useTaskRefresh(buildingId: string) {
  const qc = useQueryClient();
  return () =>
    Promise.all([
      qc.invalidateQueries({ queryKey: tasksKey(buildingId) }),
      qc.invalidateQueries({ queryKey: issuesKey(buildingId) }),
      qc.invalidateQueries({ queryKey: ["issue"] }),
      qc.invalidateQueries({ queryKey: myTasksKey }),
    ]);
}
